export * from '@mui/icons-material';

const PriorityFlagBlue = '/icons/priority_flags/flag-blue.png';
const PriorityFlagGrey = '/icons/priority_flags/flag-grey.png';
const PriorityFlagOrange = '/icons/priority_flags/flag-orange.png';
const PriorityFlagRed = '/icons/priority_flags/flag-red.png';

export {
  PriorityFlagBlue,
  PriorityFlagGrey,
  PriorityFlagOrange,
  PriorityFlagRed,
};
